import { BaseMapper } from '../../../../shared/mappers/base.mapper';
import { ShippingOrder } from '../models/shipping-order.type';

export class ShippingOrderMapper extends BaseMapper<ShippingOrder> {
   
}
